import React from "react";
import { Link } from "react-router-dom";
import { FileCheck, Database, RefreshCw, Sparkles, DollarSign, Scale } from "lucide-react";

const SECTIONS = [
  {
    icon: FileCheck,
    title: "Our Standards",
    body: "MediaCrypto covers cryptocurrency markets, blockchain technology, and digital asset regulation. We aim to publish accurate, timely, and useful information for traders, developers, and researchers. We do not accept payment in exchange for favorable editorial coverage, and our editorial team operates independently of our advertising and affiliate relationships.",
  },
  {
    icon: Database,
    title: "How We Research",
    body: "Articles are researched using primary sources where available, including regulatory filings, official government and central bank publications, company disclosures, blockchain explorers, and established market data providers. Where secondary sources are used, we aim to attribute claims to their original source rather than presenting them as our own findings.",
  },
  {
    icon: RefreshCw,
    title: "How We Verify Market Data",
    body: "Price, volume, and market statistics referenced in our coverage are sourced from live exchange APIs and established data providers at the time of writing. Because crypto markets move continuously, figures in older articles may no longer reflect current conditions; we recommend checking our live tools for real-time data.",
  },
  {
    icon: Sparkles,
    title: "How We Use AI",
    body: "AI-assisted tools may support research organization, data processing, and draft preparation for some of our content. AI does not determine our editorial conclusions or opinions. Published articles are reviewed by the MediaCrypto editorial team, and material financial, regulatory, and factual claims are checked against authoritative sources before publication.",
  },
  {
    icon: DollarSign,
    title: "Affiliate & Sponsored Content",
    body: "MediaCrypto may earn a commission through affiliate links, including exchange referral programs, disclosed within relevant articles and tools. Affiliate relationships do not influence our editorial analysis or recommendations. Any sponsored content will be clearly labeled as such.",
  },
  {
    icon: Scale,
    title: "Corrections Policy",
    body: "We are committed to correcting factual errors promptly and transparently. If you believe an article contains an inaccuracy, please contact us with details. Corrections to material errors will be noted within the affected article.",
  },
];

export default function EditorialPolicy() {
  return (
    <div className="pt-24 pb-20 max-w-3xl mx-auto px-6">
      <div className="text-center mb-12">
        <h1 className="font-display font-bold text-4xl text-[var(--text-primary)]">Editorial Policy</h1>
        <p className="mt-4 text-[var(--text-secondary)] leading-relaxed">
          How MediaCrypto researches, verifies, and publishes content.
        </p>
      </div>

      <div className="space-y-6">
        {SECTIONS.map((s) => (
          <div key={s.title} className="bg-[var(--bg-panel)] border border-[var(--border-soft)] rounded-xl p-7">
            <div className="flex items-center gap-3 mb-3">
              <s.icon className="w-5 h-5 text-yellow-400" />
              <h2 className="font-display font-bold text-lg text-[var(--text-primary)]">{s.title}</h2>
            </div>
            <p className="text-sm text-[var(--text-secondary)] leading-relaxed">{s.body}</p>
          </div>
        ))}
      </div>

      <p className="text-xs text-[var(--text-tertiary)] text-center mt-10">
        Questions about our editorial process? <Link to="/about" className="text-yellow-400 hover:underline">Contact us</Link>.
      </p>
    </div>
  );
}